import { memo } from 'react'

import { renameContentForTenant } from '@tabeeb/modules/contentReviews/actions'
import { Chip } from '@collaborate-health/uikit'
import { useDispatch } from '@tabeeb/store'

interface RenameButtonProps {
  tenantId: number
}

const RenameButton: React.FC<RenameButtonProps> = ({ tenantId }) => {
  const dispatch = useDispatch()

  if (!tenantId) {
    return null
  }

  return <Chip size='small' label='Rename' color='primary' onClick={() => dispatch(renameContentForTenant(tenantId))} />
}

export default memo(RenameButton)

